import { useState, useEffect, useContext } from 'react'
import { isPast, parseISO, isToday } from 'date-fns'
import pclnExperimentation from '@pcln/experimentation'
import BootstrapDataContext from '../../context/BootstrapDataContext'
import {
  HOTEL_SEARCH_DATA,
  getPersistedSearchDataByKeys,
  SavedSearch
} from '../../utils/local-forage-helper'
import useSeti from './useSeti'

const paidUserRef = ['GOOGLECPC', 'GOOGLECPCB', 'MSN', 'MSNB']
export default function usePrePopPrepaidSearch() {
  const { referral: { id = '', sourceId = '' } = {}, prePopData } =
    useContext(BootstrapDataContext)
  const isPaidUser = sourceId === 'PL' && paidUserRef.includes(id)
  const [recentSearches, setRecentSearches] = useState<SavedSearch | null>(null)
  useEffect(() => {
    async function getSearch() {
      if (isPaidUser && !prePopData?.hotels) {
        const data = await getPersistedSearchDataByKeys(
          [HOTEL_SEARCH_DATA],
          true
        )
        const mostRecentSearch = data.slice(0, 1).pop() || null
        if (
          mostRecentSearch?.startDate &&
          (!isPast(parseISO(mostRecentSearch.startDate)) ||
            isToday(parseISO(mostRecentSearch.startDate)))
        ) {
          setRecentSearches(mostRecentSearch)
          pclnExperimentation.fireImpression('LP_PREPOP_SEARCH_RETURN')
        }
      }
    }
    getSearch()
  }, [isPaidUser, prePopData?.hotels])
  return useSeti('LP_PREPOP_SEARCH_RETURN', false) === 'VARIANT'
    ? recentSearches
    : null
}
